import { Injectable } from "@angular/core";
import { catchError, Observable, of, ReplaySubject, tap } from "rxjs";
import { environment } from "@env/environment";
import { HttpClient } from "@angular/common/http";
import { Classe } from "./classe.interface";

@Injectable()
export class ClasseService {

    baseUrl = environment.settings_url + '/categories';
    private _myClasse: ReplaySubject<Classe> = new ReplaySubject<Classe>(1);
    private _classe: ReplaySubject<Classe> = new ReplaySubject<Classe>(1);
    private _classes: ReplaySubject<Classe[]> = new ReplaySubject<Classe[]>(1);
        
    set myClasse(value: Classe) {
        this._myClasse.next(value);
    }

    get myClasse$() {
        return this._myClasse.asObservable();
    }

    set Classe(value: Classe) {
        this._classe.next(value);
    }

    get Classe$() {
        return this._classe.asObservable();
    }

    set classes(value: Classe[]) {
        this._classes.next(value);
    }

    get classes$() {
        return this._classes.asObservable();
    }

    constructor(
        private _httpClient: HttpClient
    ) { }

    create(Classe: Classe): Observable<Classe> {
        return this._httpClient.post<Classe>(`${this.baseUrl}`, Classe)
        .pipe(
            tap((Classe) => {
                this.Classe = Classe;
                return (Classe);
            }),
            catchError((error) => {
                throw new Error(error);
            })
        );
    }
       
    delete(id: string): Observable<boolean> {
        return this._httpClient.delete<boolean>(`${this.baseUrl}/${id}`);
    }

    getClasse(id: string): Observable<Classe> {
        return this._httpClient.get<Classe>(`${this.baseUrl}/${id}`)
        .pipe(
            tap((Classe) => {
                this.Classe = Classe;
                return (Classe);
            }),
            catchError((error) => {
                throw new Error(error);
            })        
        );
    }

    getclassesAll(): Observable<Classe[]> {
        return this._httpClient.get<Classe[]>(`${this.baseUrl}`)
        .pipe(
            tap((classes) => {
                this.classes = classes;
                return (classes);
            }),
            catchError(() => of([] as Classe[]))
        );
    }

    loadClasses(): void {
        this.getclassesAll().subscribe();
    }
}